/**
 * Auth Utils - Centralized authentication functions
 */

// Perform complete logout
export const logout = () => {
  // Clear auth token
  localStorage.removeItem('token');
  
  // Optional: Clear user-related data (uncomment if needed)
  // localStorage.removeItem('user');
  // localStorage.removeItem('profile');
  
  // Dispatch logout event for components (Header, etc.)
  window.dispatchEvent(new CustomEvent('userLoggedOut'));
  
  // Redirect to login page
  window.location.href = '/account';
};

// Check if user is authenticated
export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  return Boolean(token && token !== 'undefined' && token !== 'null');
};

